


































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {NearestReportService} from '@/modules/neodash/pages/nearestReports/nearestReport.service';
import {typeReports} from '@/modules/neodash/pages/nearestReports/constants';
import {i18nMixin} from '@/modules/neodash/mixins';
import {
  fieldTypeDistanceReport,
  RoutesReportControlRequest,
  typeDistanceReport,
  TypeRequestReportRouteEnum
} from './types';
import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';

@Component({
  name: 'NearestListReports'
})
export default class NearestListReports extends Vue {
  public translate = i18nMixin.methods.i18n;
  public type: TypeRequestReportRouteEnum;
  public filterTerm: string = '';
  public idsDownloading: number[] = [];

  @Prop({required: true})
  public filters: TypeRequestReportRouteEnum;

  public originData: any[] = [];
  public requests: RoutesReportControlRequest[] = [];

  public created() {
    this.updateListAllRequests();
  }

  @Watch('filters')
  public updateListAllRequests() {
    traceLogAccess.logAction(ContextEnum.Report, `Rotas Geradas  - Filtro`, JSON.stringify(this.filters));
    this.originData = [];
    NearestReportService.listAllRequestsByType(this.filters)
        .then(lst => {
          this.requests = lst;
          const idsForGetOriginData = lst
              .map(x => x.idOrigin);

          this.report.getOriginData(idsForGetOriginData)
              .then(x => this.originData = x);
        });
  }

  public downloadReport(obj: any) {
    if (this.reportIsDownloading(obj))
      return;

    this.idsDownloading = [...this.idsDownloading, obj.idOriginal];
    traceLogAccess.logAction(ContextEnum.Report, `Rotas Geradas  - Download`, JSON.stringify(obj));
    this.report.downloadReport(obj)
        .then(x => {
          this.idsDownloading = this.idsDownloading.filter(x => x !== obj.idOriginal);
        });
  }

  public reportIsDownloading(obj: any) {
    return this.idsDownloading.indexOf(obj.idOriginal) > -1;
  }

  public get filteredOriginData(): any[] {
    return this.originData
        .filter(x => this.fields.some(z => {
          const column = (z.getter(x) || '').toString().toLowerCase();
          return column.indexOf(this.filterTerm.toLowerCase()) > -1;
        }) || !this.filterTerm)
  }

  public get report(): typeDistanceReport<any> {
    return typeReports.findOrFirst(x => x.type === this.filters);
  }

  public get fields(): fieldTypeDistanceReport<any>[] {
    return this.report.fields;
  }
}
